module.exports = __webpack_public_path__ + "img/MD.67d4b876.png";